<template>
  <router-view />
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  name: 'App',
}
</script>

<style>
html, body, #app { height: 100%; margin: 0; }
body { background: #0b1220; }
</style>
